<template>
  <div>
    <div :class="$style.box" :style="{ backgroundImage: `url(${bg})` }">
      <!-- 表单验证 -->
      <div :class="$style.bind">
        <p>账号绑定</p>
        <Field
          :class="$style.field"
          v-model.trim="formData.acc"
          :type="1"
          :pic="accIcon"
          :placeHolder="accPlaceHolder"
        ></Field>
        <Field
          :class="$style.field"
          v-model.trim="formData.pass"
          :type="1"
          :pic="passIcon"
          :placeHolder="passPlaceHolder"
          :inputType="'password'"
        ></Field>
        <div :class="$style.sure" @click="submit">确认绑定</div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Field from "@/components/Field.vue";
import { CDN_URL } from "@/config";
import { Toast } from "vant";
import { sort_ASCII } from "@/libs/utils";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      name: "绑定账号",
      accIcon: `${CDN_URL}/packet/acc_01.png`, // 账号icon
      accPlaceHolder: "请输入您的账号",
      passIcon: `${CDN_URL}/packet/pass_01.png`, // 密码icon
      bg: `${CDN_URL}/packet/bg.jpg?v=2`,
      passPlaceHolder: "请输入您的密码",
      formData: {
        acc: "",
        pass: "",
      },
    };
  },
  components: {
    Field,
  },
  computed: {
    ...mapState("kshb", {
      userInfo: "userInfo",
    }),
  },
  methods: {
    ...mapActions("kshb", {
      userBind: "userBind",
    }),
    ...mapMutations("kshb", {
      CHANGE_USERINFO: "CHANGE_USERINFO",
    }),
    async submit() {
      if (!this.formData.acc) {
        Toast("账号不能为空", 2000);
        return;
      }
      if (!this.formData.pass) {
        Toast("密码不能为空", 2000);
        return;
      }
      // 用户登录
      const pass = CryptoJS.MD5(this.formData.pass).toString().toLowerCase();
      const data = {
        user_name: this.formData.acc,
        password: CryptoJS.MD5(this.formData.pass + pass)
          .toString()
          .toLowerCase(),
        open_id: this.userInfo.open_id,
      };
      const r = await this.userBind({
        ...data,
        // sign: sort_ASCII(data),
      });
      if (r.ret === 1) {
        console.log("login bind", this.userInfo);
        this.CHANGE_USERINFO({ userInfo: r.content });
        this.$router.replace({ name: "kshb-role" });
      }
      return;
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: black;
  background-size: 100%;
  background-repeat: no-repeat;
  .bind {
    width: 300px;
    height: 240px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    > p {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .field {
      margin-top: 14px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 30px;
    }
  }
}
</style>